
export const googleTagManager = (gtmId) => {
    if (!gtmId) {
        return null;
    }

    if (document.getElementById('google-tag-manager-script-ksyb')) {
        return null;
    }

    function getCookie(name) {
      const value = '; ' + document.cookie;
      const parts = value.split('; ' + name + '=');
      if (parts.length === 2) return parts.pop().split(';').shift();
    }

    // Conditionally load jQuery if it's not already loaded
    if (typeof window.jQuery === 'undefined') {
      const jQueryScript = document.createElement('script');
      jQueryScript.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
      jQueryScript.async = true;
      document.head.appendChild(jQueryScript);
    }

    // Load the GTM script
    const script = document.createElement('script');
    script.id = 'google-tag-manager-script-ksyb';
    script.innerHTML = `
   (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `;
    document.head.appendChild(script);

    const dataLayerScript = document.createElement('script');
    dataLayerScript.type = 'text/javascript';
    dataLayerScript.textContent = `window.dataLayer = window.dataLayer || [] ;
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'GTM-MN5D67');`;
    document.head.appendChild(dataLayerScript);

    const eventListener = document.createElement('script');
    eventListener.type = 'text/javascript';
    eventListener.textContent = `
    window.addEventListener('message', function(event) {
     if (event.data && event.data.event === 'ga_client_id') {
     const clientId = event.data.clientId;
    document.cookie = '_ga=GA1.2.' + clientId + '; path=/;';
    if (typeof gtag === 'function') {
      gtag('config', 'GTM-MN5D67', { client_id: clientId });
    }
  }
});
`;
    document.head.appendChild(eventListener);

    const sendTrackingEventToParent = document.createElement('script');
    eventListener.type = 'text/javascript';
    eventListener.textContent = `function sendTrackingEventToParent(eventData) {
    window.parent.postMessage({
    event: 'tracking_event',
    data: eventData
    }, '*');
    }
    `

    document.head.appendChild(sendTrackingEventToParent);

    // Add the <noscript> iframe for GTM
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
              height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.head.appendChild(noscript);

    // Cleanup on unmount
    return () => {
      if (noscript) document.head.removeChild(noscript);
    };


};

